/// <reference path="Definitions/google.maps.d.ts" />
/// <reference path="Definitions/underscore.d.ts" />

import * as $ajax from './_ajax'
import * as $maps from './_maps'
import * as $modal from './_modal'

export interface IInitOptions {
    pageName: string
    pagePrefix: string
    locations: string[]
}

let options: IInitOptions

export function init($options: IInitOptions): void {
    options = $options

    var mapId = 'eyy'

    var mapVar = $maps.initMap({
        mapElement: $('#' + options.pagePrefix + '-map'),
        mapId: mapId,
        mapOptions: {
            zoom: 14,
        },
    })

    $.each(options.locations, function (idx: number, obj: any) {
        $maps.addMarker({
            image: $maps.markerImage(obj.color),
            location: new google.maps.LatLng(obj.lat, obj.long),
            map: mapVar,
            mapId: mapId,
            no: idx,
            onOver: function () {
                $('.' + options.pagePrefix + '-map-overlay').show()
                $('.' + options.pagePrefix + '-map-overlay').html(obj.name)
            },
            onOut: function () {
                $('.' + options.pagePrefix + '-map-overlay').hide()
            },
            onClick: function () {
                if (obj.antal > 1) {
                    $ajax.post({
                        url: '/Owner/CoordsModal',
                        data: {
                            lat: obj.lat,
                            lon: obj.long,
                        },
                        dataType: 'html',
                        success: function (res: string) {
                            $modal.show(res, true, true)
                        },
                    })
                } else {
                    location.href = '/Owner/Details/' + obj.id
                }
            },
        })
    })

    $maps.zoomToFit({
        map: mapVar,
        mapId: mapId,
    })

    $maps.addClustering({
        map: mapVar,
        mapId: mapId,
    })
}
